import React from 'react';
import { Upload } from 'antd';
import * as XLSX from 'xlsx';
import { normalizeHeader } from '../../utils/uploadTypes';
import { MAX_ROWS } from '../../utils/csvContactValidation';

const { Dragger } = Upload;

function parseExcel(file, onParsed) {
  const reader = new FileReader();
  reader.onload = (e) => {
    const workbook = XLSX.read(e.target.result, { type: 'array' });
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const rows = XLSX.utils.sheet_to_json(sheet, { defval: '', raw: false });
    const headerFields = rows.length ? Object.keys(rows[0]).map(normalizeHeader) : [];
    const normalizedRows = rows.map((row) => {
      const normalizedRow = {};
      Object.keys(row).forEach((key) => {
        normalizedRow[normalizeHeader(key)] = row[key];
      });
      return normalizedRow;
    });
    onParsed(file, normalizedRows, headerFields);
  };
  reader.readAsArrayBuffer(file);
}

export const ContactCsvUpload = ({ onFileParsed }) => {
  const beforeUpload = (file) => {
    parseExcel(file, onFileParsed);
    return false;
  };

  return (
    <Dragger accept=".xlsx" maxCount={1} showUploadList={false} beforeUpload={beforeUpload}>
      <p className="ant-upload-text">Drag an Excel file here, or click to browse</p>
      <p className="ant-upload-hint">One file (.xlsx) · up to {MAX_ROWS} rows</p>
    </Dragger>
  );
};
